export const INITIAL_LOAD = 4;

// matches the grid columns in Feed.module.scss: 2 (mobile) / 3 (tablet) / 4 (desktop)
export const POST_SIZES =
  "(max-width: 767px) 50vw, (max-width: 1023px) 33vw, 25vw";
